import { EASE_IN_OUT } from 'shared/constants/apps'

export const verticalSlideVariants = {
  enter: (direction: number) => ({
    y: direction > 0 ? '100%' : '-100%',
    opacity: 0
  }),
  center: {
    y: 0,
    opacity: 1
  },
  exit: (direction: number) => ({
    y: direction > 0 ? '-100%' : '100%',
    opacity: 0
  })
}

export function getVerticalSlideTransition(duration: number) {
  return {
    duration,
    ease: EASE_IN_OUT
  }
}
